var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"base-header-help"},[_c('div',{staticClass:"help-mark"},[_vm._v("？")]),_c('div',{staticClass:"help-text"},[_vm._v("ヘルプ")])])}]

export { render, staticRenderFns }